import React, { memo, useEffect, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';

import * as _ from 'lodash';
import { numberFormat } from 'utils';

function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

function ChartFolioVolBuy(props) {
  const DEFAULT_OPTION = {
    // chart: {
    //   events: {
    //     load() {
    //       this.showLoading();
    //       setTimeout(this.hideLoading.bind(this), 1000);
    //     }
    //   }
    // },
    grid: { top: 10, right: 15, bottom: 50, left: 40 },
    title: {
      show: false,
      text: 'Log Axis',
      left: 'center',
    },
    tooltip: {
      show: true,
      trigger: 'item',
      // formatter: '{a} <br/>{b}: {c}',
      formatter: function (value, index) {
        // console.log(value);
        // triệu
        if (props.afterFix === 'triệu') {
          if (value.value > 100000)
            return `${value.name} : ${numberFormat(
              Math.abs(value.value) / 1000
            )} tỷ`;
          if (value.value > 1000)
            return `${value.name} : ${numberFormat(
              Math.abs(value.value) / 1000,
              2
            )} tỷ`;
          return `${value.name} : ${numberFormat(Math.abs(value.value))} triệu`;
        }

        return `${value.name} : ${numberFormat(Math.abs(value.value))} ${
          props.afterFix || ''
        }`;
      },
    },
    legend: {
      show: false,
    },
    series: {
      name: 'KL giao dịch',
      type: 'treemap',
      with: '100%',
      height: '100%',
      left: '0',
      top: '0',
      right: '0',
      bottom: '0',
      squareRatio: 1,
      nodeClick: false,
      roam: false,
      label: {
        show: true,
        // formatter: '{b}({@score})',
        formatter: '{b}',
        fontSize: 12,
        color: '#27272D',
      },
      itemStyle: {
        borderColor: '#2E2D3D',
        gapWidth: 1,
      },
      breadcrumb: {
        show: false,
      },
      data: [
        {
          value: 100,
          name: ' ',
          children: [],
        },
      ],
    },
  };

  const [option, setOption] = useState(DEFAULT_OPTION);

  const { thanhKhoan, typeOrder, type } = props;

  const preTangGiam = usePrevious(thanhKhoan);
  const preTypeOrder = usePrevious(typeOrder);
  let timer;

  useEffect(() => {
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (
      thanhKhoan &&
      (!_.isEqual(thanhKhoan, preTangGiam) ||
        !_.isEqual(typeOrder, preTypeOrder))
    ) {
      _mapDataToState(thanhKhoan);
    }
  }, [thanhKhoan, typeOrder]);

  function onChartReady(echarts) {
    // console.log(echarts)
    timer = setTimeout(function () {
      echarts.hideLoading();
    }, 1000);
  }

  function _mapDataToState(res) {
    const newOption = _.cloneDeep(option);

    let objData = [];

    for (let index = 0; index < res.name.length; index++) {
      objData.push({
        name: res.name[index],
        value:
          type === 'Vol'
            ? typeOrder === 'M'
              ? res.value1[index]
              : res.ptvalue1[index]
            : typeOrder === 'M'
            ? res.value[index]
            : res.ptvalue[index],
        itemStyle: {
          color: res.color[index],
        },
      });
    }

    // newOption.xAxis.data = _data;
    newOption.series.data[0].children = objData;

    setOption(newOption);
  }

  return (
    <ReactECharts
      option={option}
      // showLoading
      // onChartReady={onChartReady}
      style={{
        height: '100%',
        width: `100%`,
      }}
    />
  );
}

export default memo(ChartFolioVolBuy);
